import React from 'react';
import PageWrapperV2 from '../page-wrapper-v2';
import PageBody from '../page-body';

interface TabLayoutProps {
    children: React.ReactNode;
    header: React.ReactNode;
    bodyClassName?: string;
    footer?: React.ReactNode;
}

export const TabLayout: React.FC<TabLayoutProps> = ({ header, children, bodyClassName, footer }) => {
    return (
        <PageWrapperV2>
            {header}
            <PageBody alignItems='flex-start' setDefaultPadding={false} className={bodyClassName}>
                {children}
            </PageBody>
            {footer}
        </PageWrapperV2>
    );
};

export default TabLayout;
